// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"55fe0664","790":"0c3116c2"}[chunkId] + ".chunk.js";
};